import React from 'react';
import _ from 'lodash';

import {
  useCustomer_FulfillmentStatusWidgetQuery,
  usePartner_FulfillmentStatusWidgetQuery
} from 'generated/graphql';

import { DateTime } from 'luxon';
import { Timeline } from 'modules/layer00';



export interface IData {
  steps: Timeline.IStep[];
}

export function usePartnerQuery(orderId: string) {
  const queryTuple = usePartner_FulfillmentStatusWidgetQuery({
    variables: {
      orderId
    }
  });

  return React.useMemo(
    () => {
      const order = queryTuple.data?.order;

      const data: IData = {
        steps: _.map(order?.lifeCycle ?? [], (step): Timeline.IStep => ({
          label: step.label,
          approvalType: step.approvalType,
          completedAt: step.completedOn ? DateTime.fromISO(step.completedOn) : null
        }))
      };

      return {
        ...queryTuple,
        data
      };
    },
    [queryTuple]
  );
}



export function useCustomerQuery(orderId: string) {
  const queryTuple = useCustomer_FulfillmentStatusWidgetQuery({
    variables: {
      orderId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        steps: _.map(queryTuple.data?.orderLite?.lifeCycle ?? [], (step): Timeline.IStep => ({
          label: step.label,
          approvalType: step.approvalType,
          completedAt: step.completedOn ? DateTime.fromISO(step.completedOn) : null
        }))
      };

      return {
        ...queryTuple,
        data
      };
    },
    [queryTuple]
  );
}
